export const scrollUp = () => {
  document.getElementsByClassName('awsui-app-layout__content')[0]?.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};
